import React, { Component } from "react";
import AppContext from "../../contexts/AppContext";

export class LeftNotifications extends Component {
    state = { items: [], unread: 0 };
    componentDidMount() {}
    render() {
        return (
            <div
                className={
                    this.context.state.leftNotification === true
                        ? "modal fade show"
                        : "modal fade "
                }
                id="sidebarModalActivity"
                tabIndex="-1"
                role="dialog"
                aria-modal="true"
            >
                <div
                    className="modal-dialog modal-dialog-vertical"
                    role="document"
                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Notifications</h4>
                            <button
                                onClick={this.context.state.showNotification}
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div
                                id="NotificationContent"
                                className="list-group list-group-flush my-n3"
                            >
                                {this.context.state.notifications.map(
                                    (item, index) => {
                                        return (
                                            <a
                                                key={index}
                                                className="list-group-item px-0"
                                            >
                                                <div className="row">
                                                    <div className="col-12 ml-n2">
                                                        <div className="small text-muted">
                                                            <strong className="text-body">
                                                                {item.body}
                                                            </strong>
                                                            .
                                                        </div>
                                                    </div>
                                                </div>
                                            </a>
                                        );
                                    }
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

LeftNotifications.contextType = AppContext;
export default LeftNotifications;



// WEBPACK FOOTER //
// ./src/components/notifications/LeftNotifications.js